export default {
  webWidget: {
    helpCenter: {
      chatButton: 'Chat with Reverb',
      title: 'Need Help?',
      searchPlaceholder: 'Search our FAQs',
      loading: 'Loading',
    },
    launcher: {
      chatLabel: 'Chat with Reverb',
      label: 'Need Help?',
    },
    contactOptions: {
      contactButton: 'Contact Us',
    },
  },
  zopim: {
    window: {
      title: 'Chat with Reverb',
    },
    prechatForm: {
      greetings: 'Our resident musicians are standing by, ask us anything!',
    },
  },
};
